import { Trans, useTranslation } from "react-i18next";
import { NumberFormatText } from "../../../components/NumberFormatText";
import KiloNewton from "../../../components/Math/Units/Metric/KiloNewton";
import { RowBody } from "../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../components/ToolTip";

function CharacteristicLoadCarryingCapacity_Germany({ Rmax, Rk }) {
  const { t } = useTranslation("translation");

  // TODO: Why ?
  let result = Rmax !== null ? Rmax : Rk !== null ? Rk : Number.NaN;

  return (
    <RowBody
      titleValue={<p>{t("inner.verificationCapacity.characteristicLoadCarryingCapacity")}</p>}
      indicesValue={
        <span>
          R<sub>k</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={result} decimalScale={0} />
        </span>
      }
      formulaValue={
        <ToolTip
          id={"DesignLoadCarryingCapacity"}
          type={IconType.INFO}
          text={
            <Trans
              i18nKey="aeussre.DrillBitDiameterInfo"
              values={{
                cnom: "c<sub>nom</sub>",
              }}
              components={{ sub: <sub /> }}
            />
          }
        />
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default CharacteristicLoadCarryingCapacity_Germany;
